const DOWNLOAD_MODAL_CONTENT = {
  firstStep: {
    remote: "Скачайте файл в&nbsp;новой&nbsp;вкладке",
    direct: "Завершите загрузку",
  },
  subtitle: {
    remote: "Если вкладка с файлом не&nbsp;открылась,",
    direct: "Если загрузка не&nbsp;началась автоматически,",
  },
  title: "Спасибо, что выбрали $softName",
};

const EXTENDED_IMAGE_HEIGHT_SOFT_UIDS = ["gdz"];

export {
  DOWNLOAD_MODAL_CONTENT,
  EXTENDED_IMAGE_HEIGHT_SOFT_UIDS,
};